import React from "react";

class ErrorScreen extends React.Component<{ errorText: string }> {
  render() {
    return (
      <div className="page-content page-content--center">
        <div className="container text-danger text-center text-huge text-w-medium">
          <p>{this.props.errorText}</p>
        </div>
      </div>

    )
  }
}

export default ErrorScreen;
